import { Extension } from "@tiptap/core";
const AddKeyboardShortcuts = Extension.create({
    name: "addKeyboardShortcuts",
    addOptions() {
        return {
            enterHandler: (editor) => { },
            shiftEnterHandler: (editor) => { },
        };
    },
    addKeyboardShortcuts() {
        return {
            Enter: ({ editor }) => {
                this.options.enterHandler(editor);
                return false; // called last because it returns false
            },
            "Shift-Enter": ({ editor }) => {
                this.options.shiftEnterHandler(editor);
                return true; // called first because it returns true
            },
        };
    },
});
export default AddKeyboardShortcuts;
